import { useEffect } from "react";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { Box, Typography } from "@mui/material";
import GeneralUtilityService from "services/GeneralUtilityService";
import useNotifications from "hooks/useNotifications";
import { useDispatch, useSelector } from "react-redux";
import { setPage } from "reducers/company/companySlice";

export const CompaniesTablePagination = ({ isLoading, paginationData }) => {
    const { renderSuccessNotification } = useNotifications();
    const dispatch = useDispatch();
    const { page } = useSelector((state) => state.companySlice.listing);

    const handlePaginationChange = (_e, selectedPage) => {
        dispatch(setPage(selectedPage));
        if (paginationData.per_page < 20) return;
        GeneralUtilityService.scrollToTop(600);
    };

    useEffect(() => {
        paginationData?.total &&
            renderSuccessNotification(
                `Found ${paginationData?.total} companies`,
            );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationData?.total]);

    return (
        <Box mt={6}>
            <Stack
                sx={{
                    width: "100%",
                }}
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={2}
            >
                <Pagination
                    page={page}
                    onChange={handlePaginationChange}
                    count={paginationData?.last_page}
                    boundaryCount={3}
                    siblingCount={3}
                    showFirstButton
                    disabled={isLoading}
                />

                <Box
                    sx={{
                        marginLeft: "auto",
                    }}
                >
                    <Typography variant="subtitle2">
                        {"Total results: "}
                        {paginationData?.total ?? " calculating..."}
                    </Typography>
                </Box>
            </Stack>
        </Box>
    );
};

export default CompaniesTablePagination;
